import React, {Suspense} from 'react';
import {erpSoftware} from "../../constants/meta";
import Meta from "../../components/common/Helmet";
// import {useTranslation} from "react-i18next";
import Loading from "../../components/common/Loading";
import ServicePage from "../../components/sections/ServicePage";

const ErpSolutions = () => {
  return (
    <div>
      <Meta
        title={erpSoftware.title}
        description={erpSoftware.description}
        canonical={erpSoftware.canonical}
        keywords={erpSoftware.keywords}
        ogTitle={erpSoftware.title}
        ogDescription={erpSoftware.description}
      />
      <Suspense fallback={<Loading />}>
        <ServicePage serviceKey={"desktop"}/>
      </Suspense>
    </div>
  );
};

export default ErpSolutions;
